import { Table, Button } from 'react-bootstrap';
import currency from 'currency.js';
import { formatDate } from '../../../../util/helper';
import '../../grn/grnDetail.css';

const DebitNoteDetail = ({ isPrint, data }) => {
  return (
    <div className={`grn-detail ${isPrint ? 'print-view me-5 ms-5' : ''}`}>
      <div className="text-center">
        <div className="mb-3">
          <h4 className="m-0 mb-2">Kanti Sweets Private Limited</h4>
          <h6 className="m-0" style={{ fontSize: '11px' }}>
            {data.branchName}
            <br />
            {data.branchAddress}
          </h6>
        </div>
        <div>
          <h5 className="mb-2">
            <b>
              <u>DEBIT NOTE</u>
            </b>
          </h5>
        </div>
      </div>
      <Table bordered striped responsive className="mt-3">
        <tbody>
          <tr>
            <th style={{ width: '10%' }}>Name</th>
            <td style={{ width: '20%' }}>{data.vendorName}</td>
            <th style={{ width: '10%' }}>Address</th>
            <td style={{ width: '30%' }}>{data.vendorAddress}</td>
            <th style={{ width: '15%' }}>Supplier GST No.</th>
            <td style={{ width: '15%' }}>{data.vendorGstNo}</td>
          </tr>
          <tr>
            <th>Invoice No.</th>
            <td>{data.supplierInvoiceNumber}</td>
            <th>Invoice Date</th>
            <td>{data.invoiceDate ? formatDate(data.invoiceDate) : 'NA'}</td>
            <th>PO No.</th>
            <td>{data.poNumber || 'NA'}</td>
          </tr>
          <tr>
            <th>PO Date</th>
            <td>{data.poDate ? formatDate(data.poDate) : 'NA'}</td>
            <th>GRN No.</th>
            <td>{data.grnNumber}</td>
            <th>GRN Date</th>
            <td>{data.grnDate ? formatDate(data.grnDate) : 'NA'}</td>
          </tr>
          <tr>
            <th>Note Number</th>
            <td>{data.debitNoteNumber}</td>
            <th>Note Date</th>
            <td>{data.debitNoteDate ? formatDate(data.debitNoteDate) : 'NA'}</td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </Table>

      <Table striped bordered className="text-center grn-detail-table">
        <thead>
          <tr>
            <th className="p-0.5">Sl No.</th>
            <th className="w-10">Item Name</th>
            <th className="w-5">Description</th>
            <th className="w-5">Rate Per Unit</th>
            <th className="trp-5">Qty Returned</th>
            <th className="trp-5">Amount without GST</th>
            <th className="trp-5">Amount with GST</th>
          </tr>
        </thead>
        <tbody>
          {data.items?.map((item, index) => {
            return (
              <tr key={item.itemId}>
                <td className="p-0.5">{index + 1}</td>
                <td className="p-0.5">{item.itemName}</td>
                <td className="p-0.5">{item.description || 'N/A'}</td>
                <td className="trp-5">{currency(item.rate).format({ symbol: '₹' })}</td>
                <td className="trp-5">{item.quantityReturning}</td>
                <td className="trp-5">{currency(item.amountWithoutGst).format({ symbol: '₹' })}</td>
                <td className="trp-5">{currency(item.amount).format({ symbol: '₹' })}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>

      {data.remarks && (
        <div className="mt-3">
          <h6>Remarks:</h6>
          <p>{data.remarks}</p>
        </div>
      )}

      {isPrint && (
        <Table style={{ width: '100%', marginTop: '60px' }}>
          <tfoot>
            <tr>
              <td width="33.33%">
                <h6>Prepared by</h6>
              </td>
              <td width="33.33%" align="center">
                <h6>Stores Incharge</h6>
              </td>
              <td width="33.33%" align="right">
                <h6>Authorised Signatory/Manager</h6>
              </td>
            </tr>
          </tfoot>
        </Table>
      )}

      {!isPrint && (
        <div className="d-flex justify-content-center mt-3">
          <Button
            href={`#/inv/debit-note/print/${data.debitNoteId}`}
            target="_blank"
            rel="noreferrer"
            style={{
              backgroundColor: '#4CAF50',
              borderRadius: '12px',
            }}
          >
            Print Debit Note
          </Button>
        </div>
      )}
    </div>
  );
};

export default DebitNoteDetail;